
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 561","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M476.2 210.1h-26.5V185h47.5c4.2 0 7-2.8 7-7v-16.8c0-4.2-2.8-7-7-7H371.5c-4.2 0-7 2.8-7 7V178c0 4.2 2.8 7 7 7H419v25.1h-26.5c-15.4 0-29.3 14-29.3 29.3V252H324v-21c0-4.2-2.8-7-7-7h-34.9c-1.4-47.5-9.8-181.5-61.4-220.6L216.5.6H67l-4.2 2.8C1.4 49.5 0 219.9 0 239.4v15.4h27.9c0 55.9 2.8 81 22.3 108.9H20.9c-4.2 0-7 2.8-7 7v128.5c0 4.2 2.8 7 7 7h48.9v54.5h30.7V394.4h81v166.2h30.7V386.1l4.2-4.2h99.2c4.2 0 7-2.8 7-7V354h40.5v12.6c0 16.8 14 29.3 29.3 29.3h83.8c16.8 0 29.3-14 29.3-29.3V240.8c0-16.7-12.5-30.7-29.3-30.7zM205.3 31.3v1.3h-1c-7.6 9.8-24.6 23.7-63.2 23.7-39.1 0-57.3-15.4-64.2-23.7h127.4c.3-.3.7-.8 1-1.3zM60 59.3c14 14 39.1 27.9 81 27.9 43.3 0 68.4-14 82.4-27.9 12.6 29.3 19.5 71.2 23.7 108.9H34.9C39.1 129.1 47.5 88.6 60 59.3zM32.1 224.1c0-8.4 0-15.4 1.4-25.1H250c0 9.8 1.4 18.2 1.4 25.1zm37.7 251.3H44.7v-81h25.1zm120.1-111.7H92.2C62.8 333 60 320.4 60 254.8h163.4c0 64.2-2.8 76.8-33.5 108.9zm103.4-13.9h-51.7c12.6-23.7 14-48.9 14-95h37.8v95zm69.8-28H324v-39.1h39.1zm111.7 41.9h-81V240.8h81z"}})])
          )
        }
      }
    